import expertiseData from "../data/expertise.json";
import ExpertiseCard from "../components/ExpertiseCard";
import { Container, Grid, Typography, Box, IconButton } from "@mui/material";
import { useState } from "react";
import EditDialog from "../components/EditDialog";
import { useEditMode } from "../context/EditModeContext";
import { Add } from "@mui/icons-material";

export default function Expertise() {
  const { isEditMode } = useEditMode();
  const [items, setItems] = useState(expertiseData);
  const [editing, setEditing] = useState<any>(null);
  const [isNew, setIsNew] = useState(false);

  const handleSave = (updated: any) => {
    if (isNew) {
      setItems(prev => [...prev, updated]);
    } else {
      setItems(prev =>
        prev.map(it => (it.title === editing?.title ? updated : it))
      );
    }
    setEditing(null);
    setIsNew(false);
  };

  const handleAdd = () => {
    setEditing({ title: "", description: "" });
    setIsNew(true);
  };

  return (
    <Container sx={{ py: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Expertise</Typography>
        {isEditMode && (
          <IconButton onClick={handleAdd} color="primary">
            <Add />
          </IconButton>
        )}
      </Box>

      <Grid container spacing={2}>
        {items.map((exp, i) => (
          <Grid key={i} size={{ xs: 12, sm: 6, md: 4 }}>
            <ExpertiseCard
              {...exp}
              onEdit={() => setEditing(exp)}
            />
          </Grid>
        ))}
      </Grid>

      {editing && (
        <EditDialog
          open={!!editing}
          item={editing}
          onSave={handleSave}
          onClose={() => { setEditing(null); setIsNew(false); }}
        />
      )}
    </Container>
  );
}
